<section class="av-billing-box">
    <div class="av-billing-box__header">
        <mat-icon>calculate</mat-icon>
        <h2>{{ 'app.billing.estimate.title' | translate }}</h2>
    </div>

    @if (isLoading()) {
    <div role="status" [attr.aria-label]="'app.billing.invoices.loading' | translate">
        <div class="av-billing-skeleton av-billing-skeleton--amount"></div>
        <div class="av-billing-skeleton av-billing-skeleton--line"></div>
        <div class="av-billing-skeleton av-billing-skeleton--line"></div>
    </div>
    } @else if (hasError()) {
    <p class="av-billing-note m-0">{{ 'app.billing.estimate.error' | translate }}</p>
    <div class="av-billing-box__actions">
        <button mat-stroked-button (click)="retry.emit()">{{ 'app.billing.actions.retry' | translate }}</button>
    </div>
    } @else if (estimate(); as data) {
    <div class="av-billing-amount">{{ data.total | currency: data.currency : 'symbol' : '1.2-2' }}</div>

    @if (data.period_end) {
    <p class="av-billing-note m-0">
        {{ 'app.billing.estimate.due_on' | translate: { date: (data.period_end * 1000 | date: 'mediumDate') } }}
    </p>
    }

    @if (data.is_trial && data.trial_ends_at) {
    <div class="av-billing-banner av-billing-banner--info">
        <span>{{ 'app.billing.estimate.trial_note' | translate: { date: (data.trial_ends_at | date: 'mediumDate') } }}</span>
    </div>
    }

    <mat-divider></mat-divider>

    <div class="d-flex flex-column gap-3">
        @for (line of data.lines; track line.component_type) {
        <div class="av-billing-row">
            <span class="av-billing-row__label">
                {{ line.label_key | translate }}
                <span class="av-billing-note">
                    {{ 'app.billing.estimate.unit' | translate: {
                            quantity: line.quantity,
                            amount: (line.unit_amount | currency: line.currency : 'symbol' : '1.2-2')
                        } }}
                </span>
            </span>
            <span class="av-billing-row__value">
                {{ line.amount | currency: line.currency : 'symbol' : '1.2-2' }}
            </span>
        </div>
        }
    </div>
    } @else {
    <p class="av-billing-note m-0">{{ 'app.billing.estimate.empty' | translate }}</p>
    }
</section>
